import axiosClient from './axiosClient';

const notificationApi = {
  markAllRead: () => axiosClient.patch('/notifications/mark-all-read'),

  clearAll: () => axiosClient.delete('/notifications/clear-all'), // 🔥 thêm dòng này
};

export default notificationApi;